import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { FormControlChildAbstract } from '~/component/form/abstracts/control-child.abstract';

import { ToggleSwitchIconNameEnum } from './enums/toggle-switch-icon-name.enum';

@Component({
  selector: 'app-form-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FormToggleSwitchComponent,
      multi: true,
    },
  ],
})
export class FormToggleSwitchComponent extends FormControlChildAbstract<boolean> {
  @Input() public label: string;
  @Input() public name: string;

  public get iconName(): ToggleSwitchIconNameEnum {
    return this.value
      ? ToggleSwitchIconNameEnum.ToggleSwitchOn
      : ToggleSwitchIconNameEnum.ToggleSwitchOff;
  }

  public onChange(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    this.value = checkbox.checked;
  }
}
